import { PublishResult } from './constants'

export const isItemPublished = (
  publishResult: PublishResult | string | undefined
) => {
  return (
    publishResult === PublishResult.Ok ||
    publishResult === PublishResult.AlreadyPublished
  )
}
